import React from "react";

import "./login-page.m.css";


const closeSvg =  <svg xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' width='16' height='16' viewBox='0 0 16 16'>
  <defs><path id='a' d='M8.957 8.25l3.397-3.396a.5.5 0 1 0-.708-.707L8.25 7.543 4.854 4.147a.5.5 0 1 0-.708.707L7.543 8.25l-3.397 3.397a.5.5 0 1 0 .708.707L8.25 8.958l3.396 3.396a.5.5 0 1 0 .708-.707L8.957 8.25z' /></defs>
  <g fill='none' fillRule='evenodd'>
    <path fill='#FFF' fillRule='nonzero' d='M0 0h16v16H0z' />
    <use fill='#858585' xlinkHref='#a' />
  </g>
</svg>

class EditProfile extends React.Component {
  constructor(props){
    super(props);
    this.defaultStruct = {
      value : '',
      isValid: true
    }
    this.state={
      name:'',
      email: this.defaultStruct,
      mob: this.defaultStruct,
    }

    this.handleValues = this.handleValues.bind(this);
    this.onClear = this.onClear.bind(this);

  }

  handleValues(e, value) {

    const regexMapper = {
      email: RegExp(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/ ),
      mob: RegExp(/[0-9]+$/)
    };
    const isValid = regexMapper[value].test(e.target.value);
    this.setState({[value]: {value : e.target.value, isValid}});
  }

  onClear(e, value) {
    e.preventDefault();
    this.setState({[value]: this.defaultStruct});
  }

  handleSubmit(){
    const {mob, email} = this.state;
    const isValid = mob.isValid && email.isValid;
    if(isValid){
      //make api call
    }
  }

  render() {
    return (<div styleName="container-wrapper">
          <div styleName="heading">Edit Profile</div>
          <div>
            <div styleName="contain-wrapper">
              <div styleName="first-row">
                <div styleName="field-wrapper">
                  <label>Name</label>
                  <input styleName="field-input" type="text" required  value={this.state.name.value} onChange={(e)=>this.handleValues(e, 'name')}></input>
                  <span styleName="close-btn" onClick={(e) => this.onClear(e, 'name')} >
                  {closeSvg}
                </span>
                </div>
                <div styleName="field-wrapper">
                  <label>Email</label>
                  <input styleName={`field-input ${!this.state.email.isValid ? 'error-msg' : ''}`} type="email" required value={this.state.email.value}
                         onChange={(e) => this.handleValues(e, 'email')} ></input>
                  <span styleName="close-btn" onClick={(e) => this.onClear(e, 'email')}>
              {closeSvg}
                </span>
                </div>
              </div>
              <div styleName="field-wrapper">
                <label>Phone</label>
                <input styleName={`field-input ${!this.state.mob.isValid ? 'error-msg' : ''}`} type="tel" maxLength="15" required value={this.state.mob.value}
                       onChange={(e)=>this.handleValues(e, 'mob')}></input>
                <span styleName="close-btn" onClick={(e) => this.onClear(e, 'mob')}>
               {closeSvg}
                </span>
              </div>
            </div>
            <button styleName="submit-btn" onClick={() => this.handleSubmit()}>Submit</button>
          </div>
        </div>
    )}
}

export { EditProfile };